import * as CountryList from 'country-list';

export default CountryList;
